
export const constants =  {

  // The options are object passed into the IntersectionObserver() constructor that controls
  // the circumstances under which the observer's callback is invoked
  INTERSECTION_OBSERVER_OPTIONS:{
    rootMargin:'0px',
    root : null,
    threshold: [0, 0.25, 0.5, 0.75, 1]
  },
  DATACAPTURE_EVENT_TYPE:{
    viewport:'viewport',
    click:'click',
    response: 'response'
  },
  TEALIUM_LINK_EVENT_TIMEOUT:1000,
  CLIENT_PREVIEWDATE_HEADER:'X-ULTA-CLIENT-PREVIEWDATETIME',
  CLIENT_STAGING_HOST_HEADER:'X-ULTA-CLIENT-STAGINGHOST',
  AKAMAI_DEVICE_CHARACTERISTICS_HEADER:'x-akamai-device-characteristics',
  PRODUCT_HIGHLIGHTER_VISIBILITY_LENGTH: 3,
  CLIENT_ACTION_TYPES:{
    GLADLY_CHAT_CLICK:'gladly::chatnow::click'
  },
  LOGIN_STATUS:{
    HARD_LOGIN:'hardLogin',
    ANONYMOUS:'anonymous'
  },
  URGENCY_TAG_TYPE: {
    THREE_PLUS_DAYS: '3+ days',
    TWO_DAYS: '2 days',
    ONE_DAY: '1 day',
    HOURS: 'Hours',
    EXTENDED: 'Extended',
    UPCOMING: 'Upcoming'
  },
  TAB_KEY:9,
  ENTER_KEY:13,
  ESC_KEY:27,
  UPARROW_KEY:38,
  DOWNARROW_KEY:40,
  SPACE_KEY:32,
  COLUMN_CONTAINER_BREAKPOINTS: {
    XL: 'extraLargeDevice',
    LG: 'largeDevice',
    MD: 'mediumDevice',
    SM: 'smallDevice'
  },
  SAVE_FOR_LATER_OPTIONS: {
    FLYOUT: 'flyout'
  },
  DELIVERY_TYPE_PICKUP: 'pickup',
  DELIVERY_TYPE_SHIP: 'ship',
  PICKUP_STORE_AVAILABILITY_STATUS: {
    COMPLETELY_AVAILABLE: 'completelyAvailable'
  },
  SEARCH_MOBILE_MODAL_CLASS: 'SearchMobile',
  PHONE_NO_FORMATTER:{ pattern: '(999) 999-9999' }
}

export default constants;
